module.exports = __webpack_public_path__ + "static/media/pe.pictogram.7d5ad551.svg";